export { default } from './discount-badge.component';
